import Vue from 'vue'
import VueRouter from 'vue-router'
import { Auth } from 'aws-amplify'
import AmplifyStore from '../store'
import CognitoSignIn from '../components/CognitoSignIn.vue'
import Upload from '../components/Upload.vue'
import Dashboard from '../components/Dashboard.vue'
import Images from '../components/Images.vue'

Vue.use(VueRouter);

  const routes = [
  { 
    path: '/auth',
    name: 'auth',
    component: CognitoSignIn
  },
  { 
    path: '/images',
    name: 'images',
    component: Images,
    meta: { requiresAuth: true}
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true}
  },  
  {
    path: '/upload',
    name: 'upload',
    component: Upload,
    meta: { requiresAuth: true}
  },
  { 
    path: '/', 
    redirect: '/dashboard'
  }
  ]

const router = new VueRouter({
  routes
});

function getUser() {
  return Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      AmplifyStore.commit('setUser', data.attributes.email);
      return data;
    }
    AmplifyStore.commit('setUser', null);
    return null;
  }).catch(() => {
    AmplifyStore.commit('setUser', null);
    return null;
  });
}

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user = await getUser();
    if (!user) {
      AmplifyStore.commit('setRedirectUrl', `${to.fullPath}`);
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath,
        }
      });
    }
    return next()
  }
  return next()
})

export default router
